// Begin: Enums  https://github.com/Vidlet/dragonApi/blob/develop/src/main/java/com/vidlet/enumeration/VideoType.java
enum VIDEO_TYPE {
  DATA = "DATA",
  FILE = "FILE",
  INSIGHT = "INSIGHT",
  MOBILE = "MOBILE",
  CLIP = "CLIP",
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  PDF = "PDF",
}
export default VIDEO_TYPE;

export enum VIDEO_UPLOAD_TYPE {
  FILE = "FILE",
  INSIGHT = "INSIGHT",
  BONUS = "BONUS",
  FOCUS_GROUP = "FOCUSGROUP",
  MODERATED = "MODERATED",
  QUESTION = "QUESTION",
}
